// extracted by mini-css-extract-plugin
export var button = "pagination-module--button--0bb62";
export var pagination = "pagination-module--pagination--fedff";
export var spin = "pagination-module--spin--221ca";